import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
let Device = class Device extends Vue {
    siteIcon = require('@blade-sxp/search-center/assets/images/backsite.png');
};
Device = __decorate([
    Component({
        name: 'device',
    })
], Device);
export default Device;
